var _process$env$ASSET_PR, _process$env$IMAGE_CD, _process$env$BASE_PAT, _process$env$COMMIT_R, _process$env$PELOTON_, _process$env$FEATURE_;

import { getCookieValue } from '@engage/cookies';
export var ASSET_PREFIX = (_process$env$ASSET_PR = process.env.ASSET_PREFIX) !== null && _process$env$ASSET_PR !== void 0 ? _process$env$ASSET_PR : '';
export var IMAGE_CDN_BASE_URL = (_process$env$IMAGE_CD = process.env.IMAGE_CDN_BASE_URL) !== null && _process$env$IMAGE_CD !== void 0 ? _process$env$IMAGE_CD : 'https://images.onepeloton.com/peloton-cycle';
export var BASE_PATH = (_process$env$BASE_PAT = process.env.BASE_PATH) !== null && _process$env$BASE_PAT !== void 0 ? _process$env$BASE_PAT : '';
export var COMMIT_REF = (_process$env$COMMIT_R = process.env.COMMIT_REF) !== null && _process$env$COMMIT_R !== void 0 ? _process$env$COMMIT_R : 'WORKING_COPY';
export var PELOTON_PLATFORM = (_process$env$PELOTON_ = process.env.PELOTON_PLATFORM) !== null && _process$env$PELOTON_ !== void 0 ? _process$env$PELOTON_ : '';
export var Environment;

(function (Environment) {
  Environment["Prod"] = "PRODUCTION";
  Environment["UAT"] = "UAT";
  Environment["Dev"] = "DEVELOPMENT";
  Environment["Local"] = "LOCAL";
  Environment["Unknown"] = "UNKNOWN";
})(Environment || (Environment = {}));

export var ApiEnvs;

(function (ApiEnvs) {
  ApiEnvs["Qa1"] = "qa1";
  ApiEnvs["Qa2"] = "qa2";
  ApiEnvs["Prod"] = "api";
  ApiEnvs["Local"] = "local-api";
  ApiEnvs["Test"] = "localhost";
})(ApiEnvs || (ApiEnvs = {}));

var SegmentKeys;

(function (SegmentKeys) {
  SegmentKeys["Dev"] = "Em42UvfYJ6TL85kvSdcRDkaxu4tOHY3H";
  SegmentKeys["Prod"] = "hPN6abP1A0hhVPr1PBu3HYo4fmqwdqXA";
  SegmentKeys["Uat"] = "qAfO6zrTICirXIMWQPBqZyc7e4BZcHc9";
})(SegmentKeys || (SegmentKeys = {}));

var OptimizelyKeys;

(function (OptimizelyKeys) {
  OptimizelyKeys["Dev"] = "JDjckEFt9bUWZiAe1HVYC";
  OptimizelyKeys["Prod"] = "NqWVD6BBusmuigiVchznq";
})(OptimizelyKeys || (OptimizelyKeys = {}));

var toEnv = function toEnv(envString) {
  switch (envString) {
    case 'PRODUCTION':
      return Environment.Prod;

    case 'UAT':
      return Environment.UAT;

    case 'DEVELOPMENT':
      return Environment.Dev;

    case 'LOCAL':
      return Environment.Local;

    default:
      return Environment.Unknown;
  }
};

var toAPIEnvironment = function toAPIEnvironment(env) {
  if (ENVIRONMENT === Environment.Prod) {
    return ApiEnvs.Prod;
  }

  var cookieValue = typeof document === 'undefined' ? null : getCookieValue('API_ENVIRONMENT');

  if (cookieValue === ApiEnvs.Qa1 || env === ApiEnvs.Qa1) {
    return ApiEnvs.Qa1;
  } else if (cookieValue === ApiEnvs.Qa2 || env === ApiEnvs.Qa2) {
    return ApiEnvs.Qa2;
  } else if (cookieValue === ApiEnvs.Prod || env === ApiEnvs.Prod) {
    return ApiEnvs.Prod;
  }

  return ApiEnvs.Qa1;
};

export var ENVIRONMENT = toEnv(process.env.ENVIRONMENT);
export var APP_VERSION_NUMBER = process.env.APP_VERSION_NUMBER;
export var API_ENVIRONMENT = toAPIEnvironment(process.env.API_ENVIRONMENT);
export var HOSTNAME = typeof window !== 'undefined' ? window.location.hostname : process.env.HOSTNAME;
export var FEATURE_TOGGLES = JSON.parse((_process$env$FEATURE_ = process.env.FEATURE_TOGGLES) !== null && _process$env$FEATURE_ !== void 0 ? _process$env$FEATURE_ : '{}');
export var isProdEnv = function isProdEnv(env) {
  return env === Environment.Prod;
};
export var isUatEnv = function isUatEnv(env) {
  return env === Environment.UAT;
};
export var isDevEnv = function isDevEnv(env) {
  return env === Environment.Dev;
};
export var isLocalEnv = function isLocalEnv(env) {
  return env === Environment.Local;
};
export var isUnknownEnv = function isUnknownEnv(env) {
  return env === Environment.Unknown;
};
export var isNonProdEnv = function isNonProdEnv(env) {
  return isUatEnv(env) || isDevEnv(env) || isLocalEnv(env);
};

var toSegmentKey = function toSegmentKey() {
  switch (ENVIRONMENT) {
    case Environment.Dev:
      return SegmentKeys.Dev;

    case Environment.Prod:
      return SegmentKeys.Prod;

    case Environment.UAT:
      return SegmentKeys.Uat;

    case Environment.Local:
      return SegmentKeys.Dev;

    default:
      return '';
  }
};

export var SEGMENT_KEY = toSegmentKey();

var toOptimizelyKey = function toOptimizelyKey() {
  switch (ENVIRONMENT) {
    case Environment.Prod:
      return OptimizelyKeys.Prod;

    default:
      return OptimizelyKeys.Dev;
  }
};

export var OPTIMIZELY_KEY = toOptimizelyKey();
export var toAssetPath = function toAssetPath(path) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$assetPrefix = _ref.assetPrefix,
      assetPrefix = _ref$assetPrefix === void 0 ? ASSET_PREFIX : _ref$assetPrefix;

  if (assetPrefix !== '') {
    // drop trailing slash from asset prefix and leading slash from path, the join (ensuring exactly one "/")
    return [assetPrefix.replace(/\/$/, ''), path.replace(/^\//, '')].join('/');
  }

  return path;
};